import ExpandAllButton from "@common/table/buttons/expandAllButton"
import ExpandButton from "@common/table/buttons/expandButton"
import { showExpandColumn } from "@common/table/column.util"
import CheckboxStyled from "@common/forms/inputs/checkboxStyled"
import { TableOptions, TableRowProps } from "@common/table/types"
import { Column } from "@tanstack/react-table"
import { useMemo } from "react"

const commonDisplayProps = {
  enableSorting: false,
  enableGrouping: false,
  type: "display",
  size: 30,
  minSize: 30,
}
export const useDisplayColumns = ({
  tableOptions,
  grouping,
}: {
  tableOptions: TableOptions
  grouping: string[]
}) =>
  useMemo(
    () =>
      (
        [
          tableOptions.enableRowActions && {
            id: "row-actions",
            ...commonDisplayProps,
            minSize: 100,
            maxSize: 300,
            size: 100,
          },
          showExpandColumn(tableOptions, grouping) && {
            cell: ({ row, table }: TableRowProps) =>
              row.getCanExpand() && (
                <div
                  style={{
                    paddingLeft: `${row.depth * 1}rem`,
                  }}
                  className="flex justify-center"
                >
                  <ExpandButton row={row} table={table} />
                </div>
              ),
            header: tableOptions.enableExpandAll
              ? ({ table }: TableRowProps) => <ExpandAllButton table={table} />
              : null,
            id: "row-expand",
            ...commonDisplayProps,
          },

          tableOptions.enableRowSelection && {
            id: "row-select",
            header: ({ table }: TableRowProps) => (
              <label
                className="flex items-center justify-center w-full"
                htmlFor="head-select"
              >
                <CheckboxStyled
                  {...{
                    checked: table.getIsAllRowsSelected(),
                    indeterminate: table.getIsSomeRowsSelected(),
                    onChange: table.getToggleAllRowsSelectedHandler(),
                    id: "head-select",
                  }}
                />
              </label>
            ),
            cell: ({ row }: TableRowProps) => (
              // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
              <label
                style={{
                  paddingLeft: `${row.depth * 1}rem`,
                }}
                className="flex items-center justify-center"
                htmlFor={"row-select" + row.id}
              >
                <CheckboxStyled
                  {...{
                    checked: row.getIsSelected(),
                    disabled: !row.getCanSelect(),
                    indeterminate: row.getIsSomeSelected(),
                    onChange: row.getToggleSelectedHandler(),
                    id: "row-select" + row.id,
                  }}
                />
              </label>
            ),
            ...commonDisplayProps,
          },
        ] as unknown as Column<any>[]
      ).filter(Boolean),
    [grouping, tableOptions]
  )
